import {
  VOLUNTEER_APPLY_REQUEST,
  VOLUNTEER_APPLY_SUCCESS,
  VOLUNTEER_APPLY_FAIL,
  VOLUNTEER_APPLY_RESET,
} from "../constants/volunteerApplicationConstants";

export const volunteerApplyReducer = (state = {}, action) => {
  switch (action.type) {
    case VOLUNTEER_APPLY_REQUEST:
      return {
        loading: true,
      };
    case VOLUNTEER_APPLY_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case VOLUNTEER_APPLY_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case VOLUNTEER_APPLY_RESET:
      return {};
    default:
      return state;
  }
};
